module.exports = __webpack_public_path__ + "static/img/muyumeirong.1cabf511.jpg";